import axios from 'axios';
import store from '/store';
import { empresa } from '/store/empresas';

const MAX_REQUESTS_COUNT = 10
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0

export let baseURL = empresa.endpoint;


if (/(drop\.studiogt\.com\.br)/.test(location.href) && 'undefined' != typeof window.cordova) {
    //baseURL = location.origin + location.pathname + 'api'
    //baseURL = 'http://localhost/clic-web-new/api'
    //baseURL = 'http://localhost/studiogt/vila-rica-completo/area-do-cliente/api'
    //baseURL = 'https://www.vilarica.com.br/area-do-cliente/api'
}

if (/vilarica\.localhost/.test(location.href)) {
    baseURL = 'http://vilarica.localhost/studiogt/vila-rica-completo/area-do-cliente/api'
}
if (/vilarica\.vmstudio/.test(location.href)) {
    baseURL = 'http://vilarica.vmstudio/vila-rica/area-do-cliente/back/api'
}

export const api_endpoint = baseURL

const instance = axios.create({
    baseURL
});

instance.interceptors.request.use(config => {
    if (store.state && store.state.jwt) {
        let jwt = store.state.jwt;
        if (!config.params) {
            config.params = {};
        }
        config.params.jwt = jwt;
    }
    return config;
});
instance.interceptors.request.use(function (config) {
    return new Promise((resolve, reject) => {
        let interval = setInterval(() => {
            if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
                PENDING_REQUESTS++
                clearInterval(interval)
                resolve(config)
            }
        }, INTERVAL_MS)
    })
})

instance.interceptors.response.use(function (response) {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.resolve(response)
}, function (error) {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    if (error.response && error.response.status == 401) {
        console.error(error.request, error.response);
        try {
            store.dispatch('setJwt', null);
            store.dispatch('refresh');
        } catch (err) {
            console.error(err);
        }
    }
    return Promise.reject(error)
})

export const api = instance

export default instance;

